import fetch from "../utils/fetch";

const API = {
  getAuth: "oauth/createAuthCode", //登录
  Login: "oauth/authCodeLogin", //登录
  weChatOAuth: "oauth/render/weixin", //拉取微信授权
  UnionPayOAuth: "oauth/render/unionpay", //拉取云闪付授权
  weChatSdk: "message/shareLink",

  uploadFile: "appInfo/admin/uploadfile", //上传接口
  downFile: "/appInfo/admin/downFile?icon=", //下载接口

  recommend_cate: "HomeRecommendCate/getList", // 首页推荐分类产品
  recommend_hot: "HomeRecommendHot/getList", // 首页推荐热门产品

  cate_list: "category/list", //产品分类--商品列表添加商品的select
  dealer_app_list: "category/dealerAppList", // 产品分类--商品列表添加商品的select

  dealer_app_detail: "dealAppPriceInfo/getAppDetail", // 商品详情
  dealer_app_price: "dealAppPriceInfo/getPrice", // 商品价格
  dealer_app_area: "appGame/getAreaInfo", // 商品大区
  dealer_app_serv: "appGame/getServInfo", // 商品服务器

  paySubmit: "pay/pay",
  paySuccess: "pay/updateOrderStatusByActiveQuery", // 订单状态
  getForntToken: "oauth/getFrontToken/unionpay", // 获取云闪付前台token

  order_detail: "frontOrder/queryOrderDetail", // 未支付订单去支付，获取订单详情
  order_status: "frontOrder/queryOrderStatus", // 订单状态
  order_list: "frontOrder/queryOrderList", // 订单列表
  order_delete: "frontOrder/delete", // 订单删除
  order_close: "frontOrder/closeOrder", // 订单删除
  order_card: "frontOrder/queryCardPwdByIdAndCardNo", // 查看卡密
  order_pay: "/pay/getPayType", // 支付方式

  app_search_list: "dealAppPriceInfo/appSearchList", //热门产品检索
  getDialogAndBanner: "HomeRecommendHot/getDialogAndBanner", //618弹窗和banner
  getLikeAppInfo: "HomeRecommendHot/getLikeAppInfo",
  // TFT
  dealer_tft_list: "dealerAppTft/showDealerTftList", //天府通商品列表d

  third_order_pay: "/third/getPayType", //获取第三方支付类型
  flyPigGetCouponLinkInfo: "third/getCouponLinkInfo", //飞猪按照appId获取对应卡券基本配置信息
  fly_pig_check_card: "third/checkCardInfo", //飞猪校验一卡通卡号密码信息
  fly_pig_app_Info: "third/getAppInfo", //飞猪获取商品详情信息
  fly_pig_order: "third/getOrderInfo", //飞猪获取订单详情页
  fly_pig_app_price: "third/getThirdPrice", //飞猪商品价格
  fly_pig_third_pay: "pay/thirdPaySubmit", //飞猪提交订单
  fly_pig_order_card: "third/queryCardPwdByIdAndCardNo" // 飞猪查看卡密
};

export function apiLogin(userInfo) {
  // 编码函数：encodeURIComponent()
  // 解码函数：decodeURIComponent()
  const BusinessID = userInfo.BusinessID;
  const Data = encodeURIComponent(userInfo.Data);
  const IsWxAuth = userInfo.isWxAuth;
  console.log(Data);

  const data = {
    businessID: BusinessID,
    data: Data,
    isWxAuth: IsWxAuth
  };

  return fetch({
    url: API.Login,
    method: "post",
    data
  });
}

export function apiLogout() {
  return fetch({
    url: API.Logout,
    method: "post"
  });
}

export function apiGetInfo(token) {
  return fetch({
    url: API.getUserInfo,
    method: "get",
    params: { token }
  });
}

export function WeChatOAuth() {
  const data = {
    type: "oauth"
  };

  return fetch({
    url: API.weChatOAuth,
    method: "post",
    data
  });
}
export function UnionPayOAuth() {
  const data = {
    type: "oauth"
  };

  return fetch({
    url: API.UnionPayOAuth,
    method: "post",
    data
  });
}

export default API;



// WEBPACK FOOTER //
// ./src/api/api.js